const CART_ADD_TO_CART = "CART_ADD_TO_CART";
const CART_REMOVE_FROM_CART = "CART_REMOVE_FROM_CART";

const REGISTRATION_STEPS_SET_STEP = "REGISTRATION_STEPS_SET_STEP";
const REGISTRATION_STEPS_SELECT_SUBSCRIPTION = "REGISTRATION_STEPS_SELECT_SUBSCRIPTION";
const REGISTRATION_STEPS_LOAD_USER = "REGISTRATION_STEPS_LOAD_USER";
const REGISTRATION_STEPS_SET_EMAIL_VERIFIED = "REGISTRATION_STEPS_SET_EMAIL_VERIFIED";
const REGISTRATION_STEPS_SET_REGISTRATION_ERROR = "REGISTRATION_STEPS_SET_REGISTRATION_ERROR";
const REGISTRATION_STEPS_SET_AMOUNT = "REGISTRATION_STEPS_SET_AMOUNT";

const DASHBOARD_SET_USER_ID = "DASHBOARD_SET_USER_ID";
const DASHBOARD_SET_USER = "DASHBOARD_SET_USER";
const DASHBOARD_SET_SUBSCRIPTION = "DASHBOARD_SET_SUBSCRIPTION";
const DASHBOARD_LOAD_HISTORY = "DASHBOARD_LOAD_HISTORY";

const PURCHASE_SET_ADDONS = "PURCHASE_SET_ADDONS";
const PURCHASE_SET_SUBSCRIPTION = "PURCHASE_SET_SUBSCRIPTION";
const PURCHASE_SET_AMOUNT = "PURCHASE_SET_AMOUNT";
const PURCHASE_ADD_ADDON = "PURCHASE_ADD_ADDON";
const PURCHASE_REMOVE_ADDON = "PURCHASE_REMOVE_ADDON";

const CART = {
    CART_ADD_TO_CART,
    CART_REMOVE_FROM_CART,
}

const REGISTRATION_STEPS = {
    REGISTRATION_STEPS_SET_STEP,
    REGISTRATION_STEPS_SELECT_SUBSCRIPTION,
    REGISTRATION_STEPS_LOAD_USER,
    REGISTRATION_STEPS_SET_EMAIL_VERIFIED,
    REGISTRATION_STEPS_SET_REGISTRATION_ERROR,
    REGISTRATION_STEPS_SET_AMOUNT,
}

const DASHBOARD = {
    DASHBOARD_SET_USER_ID,
    DASHBOARD_SET_USER,
    DASHBOARD_SET_SUBSCRIPTION,
    DASHBOARD_LOAD_HISTORY,
}

const PURCHASE = {
    PURCHASE_SET_ADDONS,
    PURCHASE_SET_SUBSCRIPTION,
    PURCHASE_SET_AMOUNT,
    PURCHASE_ADD_ADDON,
    PURCHASE_REMOVE_ADDON,
}

const types = {
    ...CART,
    ...REGISTRATION_STEPS,
    ...DASHBOARD,
    ...PURCHASE,
}

export default types;
